import globalAxios from 'axios';
import {
  Configuration as SearchConfiguration,
  SearchProductAPIApi,
  SearchUniverseAPIApi
} from "../api/search";
import { getAuthHeader, getToken } from "./TokenTools";

import {
  CommunicationApi,
  Configuration as ComunicationConfiguration,
  TemplateApi
} from "../api/communication";
import {
  AmandaServiceManagementAPIApi,
  AskForProductDetailsApi,
  BuyerFavoritesApiApi,
  BuyerOrdersApiApi,
  BuyerPersonalDataAPIApi,
  BuyerShippingOptionsAPIApi,
  BuyerShippingWithCustomCartAPIApi,
  BuyerShoppingCartAPIApi,
  Configuration as CustomerConfiguration,
  SellerCategoriesManagementAPIApi,
  SellerOrdersApiApi,
  SellerProductAPIApi,
  SellerStripeConnectAPIApi
} from "../api/customer";
import {
  DroppointsApi,
  Configuration as LocationsConfiguration,
  DroppointApi
} from "../api/locations";

import {
  Configuration as AfterSaleConfiguration,
  ResellExpetidionApi
} from "../api/aftersale";
import {
  CustomerAPIV2Api,
  CustomerAPIV2ApiInterface,
  Configuration as CustomerV2Configuration
} from "../api/customer_v2";

import AmandaApi from 'src/api/services/amanda/amandaApi';
import CatalogApi from 'src/api/services/catalog/catalogApi';
import {
  Configuration as AddressConfiguration,
  UserApi
} from "../api/address";
import {
  ArticleContentApi,
  Configuration as HelpConfiguration
} from "../api/help";
import {
  ImageServiceApi,
  Configuration as IntegrationConfiguration,
  IntegrationL10nLionatApi,
} from "../api/integration";
import {
  Configuration as Searchv2Configuration,
  SearchGridAPIApi as Searchv2GridAPIApi,
  SearchGroupAPIApi as Searchv2GroupAPIApi,
  SearchProductAPIApi as Searchv2ProductAPIApi
} from "../api/search_v2";
import { getApiResellHost, isLocal } from "./BasePathTools";
import { getEnv } from "./EnvironmentTools";
import ShoppingCartApi from 'src/api/services/shoppingCart/shoppingCart';
import { getOvixiaTokenFromCookie } from "./utils";
import { oauthInterceptor } from "./oauth/interceptor";
import StoreFrontApi from 'src/api/services/storeFront/storeFront';

globalAxios.interceptors.request.use(
  async (config) => oauthInterceptor(config),
)
export class OpenapiSingleton {
  private static _search: SearchConfiguration = null;
  private static _customer: CustomerConfiguration = null;
  private static _customerV2: CustomerV2Configuration = null;
  private static _address: AddressConfiguration = null;
  private static _integration: IntegrationConfiguration = null;
  private static _help: HelpConfiguration = null;
  private static _searchv2: SearchConfiguration = null;
  private static _afterSale: AfterSaleConfiguration = null;
  private static _locations: LocationsConfiguration = null;
  private static _amandaApi: AmandaApi = null;
  private static _catalogApi: CatalogApi = null;
  private static _communication: ComunicationConfiguration = null;
  private static _shoppingCart: ShoppingCartApi = null;
  private static _storeFrontApi: StoreFrontApi = null;

  private static get search(): SearchConfiguration {
    if (!OpenapiSingleton._search) {
      OpenapiSingleton._search = new SearchConfiguration({
        basePath: getApiResellHost(),
      });
    }
    return OpenapiSingleton._search;
  }

  private static get customer(): CustomerConfiguration {
    if (!OpenapiSingleton._customer) {
      OpenapiSingleton._customer = new CustomerConfiguration({
        basePath: getApiResellHost(),
        baseOptions: {
          headers: isLocal
            ? { Authorization: "Bearer " + getToken().token }
            : getOvixiaTokenFromCookie()
              ? { Authorization: "Bearer " + getOvixiaTokenFromCookie() }
              : {},
        }
      });
    }
    return OpenapiSingleton._customer;
  }

  private static get customer_V2(): CustomerV2Configuration {
    if (!OpenapiSingleton._customerV2) {
      OpenapiSingleton._customerV2 = new CustomerV2Configuration({
        basePath: getApiResellHost(),
        baseOptions: {
          headers: isLocal
            ? { Authorization: "Bearer " + getToken().token }
            : getOvixiaTokenFromCookie()
              ? { Authorization: "Bearer " + getOvixiaTokenFromCookie() }
              : {},
        }
      });
    }
    return OpenapiSingleton._customerV2;
  }

  private static get address(): AddressConfiguration {
    if (!OpenapiSingleton._address) {
      OpenapiSingleton._address = new AddressConfiguration({
        basePath: isLocal ?  "" : getEnv().zaraHost , 
        baseOptions: {
          headers: {
            ...getAuthHeader(),
            ...(isLocal
              ? {
                  WCToken: getToken().WCToken,
                  WCTrustedToken: getToken().WCTrustedToken,
                }
              : {}),
          }
        }
      });
    }
    return OpenapiSingleton._address;
  }

  private static get integration(): IntegrationConfiguration {
    if (!OpenapiSingleton._integration) {
      OpenapiSingleton._integration = new IntegrationConfiguration({
        basePath: isLocal ?  "" : getEnv().resellOShiftHost,
        baseOptions: {
          headers: {
            ...getAuthHeader(),
            ...(isLocal
              ? {
                  WCToken: getToken().WCToken,
                  WCTrustedToken: getToken().WCTrustedToken,
                }
              : {}),
          }
        }
      });
    }
    return OpenapiSingleton._integration;
  }

  private static get help(): HelpConfiguration {
    if (!OpenapiSingleton._help) {
      OpenapiSingleton._help = new HelpConfiguration({
        basePath: isLocal ? "" : getEnv().zaraHost,  
        baseOptions: {
          headers: {
            ...getAuthHeader(),
            ...(isLocal
              ? {
                  WCToken: getToken().WCToken,
                  WCTrustedToken: getToken().WCTrustedToken,
                }
              : {}),
          }
        }
      });
    }
    return OpenapiSingleton._help;
  }

  private static get search_v2(): Searchv2Configuration {
    if (!OpenapiSingleton._searchv2) {
      OpenapiSingleton._searchv2 = new Searchv2Configuration({
        basePath: getApiResellHost(),
      });
    }
    return OpenapiSingleton._searchv2;
  }

  private static get afterSale(): AfterSaleConfiguration {
    if (!OpenapiSingleton._afterSale) {
      OpenapiSingleton._afterSale = new AfterSaleConfiguration({
        basePath: isLocal ? "" : getEnv().resellOShiftHost,  
        baseOptions: {
          headers: {
            ...getAuthHeader(),
            ...(isLocal
              ? {
                  WCToken: getToken().WCToken,
                  WCTrustedToken: getToken().WCTrustedToken,
                  token: getToken().token,
                }
              : {}),
          }
        }
      });
    }
    return OpenapiSingleton._afterSale;
  }

  private static get locations(): LocationsConfiguration {
    if(!OpenapiSingleton._locations){
      OpenapiSingleton._locations = new LocationsConfiguration({
        basePath: isLocal ? "" : getEnv().zaraHostLocations,
      })
    }
    return OpenapiSingleton._locations;
  }

  private static get amandaApi(): AmandaApi {
    if (!OpenapiSingleton._amandaApi) {
      OpenapiSingleton._amandaApi = new AmandaApi();
    }
    return OpenapiSingleton._amandaApi;
  }

  
  private static get catalogApi(): CatalogApi {
    if (!OpenapiSingleton._catalogApi) {
      OpenapiSingleton._catalogApi = new CatalogApi();
    }
    return OpenapiSingleton._catalogApi;
  }
  
  private static get shoppingCart(): ShoppingCartApi {
    if (!OpenapiSingleton._shoppingCart) {
      OpenapiSingleton._shoppingCart = new ShoppingCartApi({
        basePath: isLocal ? "" : getEnv().zaraHost,  
        baseOptions: {
          headers: {
            ...getAuthHeader(),
            ...(isLocal
              ? {
                  WCToken: getToken().WCToken,
                  WCTrustedToken: getToken().WCTrustedToken,
                  token: getToken().token,
                }
              : {}),
          }
        }
      });
    }
    return OpenapiSingleton._shoppingCart;
  }

  private static get storeFrontApi(): StoreFrontApi {
    if (!OpenapiSingleton._storeFrontApi) {
      OpenapiSingleton._storeFrontApi = new StoreFrontApi({
        basePath: isLocal ? "" : getEnv().zaraHost
      });
    }
    return OpenapiSingleton._storeFrontApi;
  }

  private static get communication(): ComunicationConfiguration {
    if(!OpenapiSingleton._communication){
      OpenapiSingleton._communication = new ComunicationConfiguration({
        basePath: isLocal ?  "" : getEnv().resellOShiftHost,
        baseOptions: {
          headers: {
            ...getAuthHeader(),
            ...(isLocal
              ? { Authorization: "" }
              : {}),
          }
        }
      })
    }
    return OpenapiSingleton._communication;
  }
  
  /// Search Api Instances

  public static get searchProductsApi(): SearchProductAPIApi {
    return new SearchProductAPIApi(OpenapiSingleton.search);
  }

  public static get SearchUniverseAPIApi(): SearchUniverseAPIApi {
    return new SearchUniverseAPIApi(OpenapiSingleton.search);
  }

  /// Customer Api Instances

  public static get SellerProductAPIApi(): SellerProductAPIApi {
    return new SellerProductAPIApi(OpenapiSingleton.customer);
  }

  public static get CustomerBuyerOrdersApi(): BuyerOrdersApiApi {
    return new BuyerOrdersApiApi(OpenapiSingleton.customer);
  }

  public static get BuyerShoppingCartAPIApi(): BuyerShoppingCartAPIApi {
    return new BuyerShoppingCartAPIApi(OpenapiSingleton.customer);
  }

  public static get BuyerShippingOptionsAPIApi(): BuyerShippingOptionsAPIApi {
    return new BuyerShippingOptionsAPIApi(OpenapiSingleton.customer);
  }

  public static get SellerStripeConnectAPIApi(): SellerStripeConnectAPIApi {
    return new SellerStripeConnectAPIApi(OpenapiSingleton.customer);
  }

  public static get SellerCategoriesManagementAPIApi(): SellerCategoriesManagementAPIApi {
    return new SellerCategoriesManagementAPIApi(OpenapiSingleton.customer);
  }

  public static get BuyerPersonalDataAPIApi(): BuyerPersonalDataAPIApi {
    return new BuyerPersonalDataAPIApi(OpenapiSingleton.customer);
  }

  public static get AmandaServiceManagementAPIApi(): AmandaServiceManagementAPIApi {
    return new AmandaServiceManagementAPIApi(OpenapiSingleton.customer);
  }

  public static get SellerOrdersApiApi(): SellerOrdersApiApi {
    return new SellerOrdersApiApi(OpenapiSingleton.customer);
  }

  public static get BuyerOrdersApiApi(): BuyerOrdersApiApi {
    return new BuyerOrdersApiApi(OpenapiSingleton.customer);
  }

  public static get AskForProductDetailsApi(): AskForProductDetailsApi {
    return new AskForProductDetailsApi(OpenapiSingleton.customer);
  }

  public static get BuyerFavoritesApiApi(): BuyerFavoritesApiApi {
    return new BuyerFavoritesApiApi(OpenapiSingleton.customer);
  }
  public static get  BuyerShippingWithCustomCartAPIApi():BuyerShippingWithCustomCartAPIApi {
    return new BuyerShippingWithCustomCartAPIApi(OpenapiSingleton.customer)
  }

  /// Customer V2 Api Instances

  public static get CustomerAPIV2Api(): CustomerAPIV2ApiInterface {
    return new CustomerAPIV2Api(OpenapiSingleton.customer_V2);
  }

  /// Address Api Instances

  public static get addressUserApi(): UserApi {
    return new UserApi(OpenapiSingleton.address);
  }

  /// Integration Api Instances

  public static get IntegrationL10nLionatApi(): IntegrationL10nLionatApi {
    return new IntegrationL10nLionatApi(OpenapiSingleton.integration);
  }

  public static get imageServiceApi(): ImageServiceApi {
    return new ImageServiceApi(OpenapiSingleton.integration);
  }


  // Help Api Instances

  public static get articleContentApi(): ArticleContentApi {
    return new ArticleContentApi(OpenapiSingleton.help);
  }

  /// Search v2 Api Instances

  public static get Searchv2GridAPIApi(): Searchv2GridAPIApi {
    return new Searchv2GridAPIApi(OpenapiSingleton.search_v2);
  }

  public static get Searchv2ProductsAPIApi(): Searchv2ProductAPIApi {
    return new Searchv2ProductAPIApi(OpenapiSingleton.search_v2);
  }

  public static get Searchv2GroupAPIApi(): Searchv2GroupAPIApi {
    return new Searchv2GroupAPIApi(OpenapiSingleton.search_v2);
  }

  // AfterSale Resell Expedition Api instance
  
  public static get ResellExpetidionApi(): ResellExpetidionApi {
    return new ResellExpetidionApi(OpenapiSingleton.afterSale);
  }
  /// Location Api Instances 

  public static get DropPointsApi(): DroppointsApi {
    return new DroppointsApi(OpenapiSingleton.locations)
  }

  public static get DroppointApiSingle(): DroppointApi {
    return new DroppointApi(OpenapiSingleton.locations)
  }
  

  /// Amanda Api Instance

  public static get AmandaApiInstance(): AmandaApi {
    return OpenapiSingleton.amandaApi;
  }

  /// Catalog Api Instance

  public static get CatalogApiInstance(): CatalogApi {
    return OpenapiSingleton.catalogApi;
  }
  
  /// Communication Api Instances

  public static get CommunicationApi(): CommunicationApi {
    return new CommunicationApi(OpenapiSingleton.communication);
  }
  public static get TemplateApi(): TemplateApi {
    return new TemplateApi(OpenapiSingleton.communication);
  }

   /// Z-Shopping Cart Api Instances

   public static get ZShoppingCartInstance(): ShoppingCartApi {
    return OpenapiSingleton.shoppingCart;
  }

     /// StoreFront Api Instances

  public static get storeFront(): StoreFrontApi {
    return OpenapiSingleton.storeFrontApi;
  }

}
